import domain from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'Openmarket',
  code: 'openmarket' as const,
  supportEmail: env('FINSIGHT_WEB___SUPPORT__EMAIL'),
  hostname: `${ domain.openmarketDomain }`,
  ga: {
    trackingId: env('GA__TRACKING_ID_OPENMARKET'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_OPENMARKET__GTM_ID'),
  },
  api: {
    external: `${ domain.protocol }//${ domain.openmarketDomain }`,
    internal: env('OPENMARKET_WS__HOSTNAME_INTERNAL'),
  },
};

export default config;
